
import ContentApi from './ContentApi';
export default ContentApi;
